// extracted by mini-css-extract-plugin
export default {"optionsLegend_rowDiv":"OptionsLegend_optionsLegend_rowDiv__KZ3BQ","optionsLegend_optionTextDiv":"OptionsLegend_optionsLegend_optionTextDiv__ELHjg"};